import { useMemo } from 'react';

import { useAgentManager } from '../providers/AgentProvider';
import { useThreadState } from '../store/useChatStore';

export const useChat = () => {
  const {
    canConsumeMoreCredits,
    isRunning,
    sendMessage,
    sendProgrammaticMessage,
    currentThreadId,
    creditAnalyticsParams,
    onShowPlansModal,
  } = useAgentManager();
  const state = useThreadState(currentThreadId);

  return useMemo(
    () => ({
      canConsumeMoreCredits,
      creditAnalyticsParams,
      currentThreadId,
      isRunning,
      onShowPlansModal,
      sendMessage,
      sendProgrammaticMessage,
      state,
    }),
    [
      canConsumeMoreCredits,
      currentThreadId,
      isRunning,
      sendMessage,
      sendProgrammaticMessage,
      state,
      creditAnalyticsParams,
      onShowPlansModal,
    ],
  );
};
